// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading_content__NSG-A {
  text-align: center;
}

.Loading_progressBar__PhjZa {
  margin-top: 40px;
}

.Loading_response__c4lcU {
  max-width: none;
  margin: 20px 0;
}
.Loading_response__c4lcU p {
  line-height: 24px;
  font-size: 14px;
  color: #7c1028;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Loading/Loading.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AAKJ;;AAFA;EACI,gBAAA;AAKJ;;AAFA;EACI,eAAA;EACA,cAAA;AAKJ;AAHI;EACI,iBAAA;EACA,eAAA;EACA,cCeE;ADVV","sourcesContent":["@use 'styles/colors.scss';\n\n.content{\n    text-align: center;\n}\n\n.progressBar{\n    margin-top: 40px;\n}\n\n.response{\n    max-width: none;\n    margin: 20px 0;\n\n    p{\n        line-height: 24px;\n        font-size: 14px;\n        color: colors.$danger7;\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"content": `Loading_content__NSG-A`,
	"progressBar": `Loading_progressBar__PhjZa`,
	"response": `Loading_response__c4lcU`
};
export default ___CSS_LOADER_EXPORT___;
